import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.ZeroAmountFormPart', {
    headline: 'How should 0 amount be handled?',
    notConsider: 'Ignore 0 amount and do not display the budget',
    consider: 'Display the budget with 0 amount',
    learnMore: 'Learn more',
});
